import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from '@sodraberget/app-map';
import reportWebVitals from './reportWebVitals';

const apiUrl = process.env.REACT_APP_API_URL ?? '';

ReactDOM.render(
  <React.StrictMode>
    <App apiUrl={apiUrl}/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
